export const ComponentType = {
    MAIN_NAVIGATION: 'Main Navigation',
    SUBNAVIGATION: 'Subnavigation',
};
// Animation durations in milliseconds
export const TIMEOUT_ENTER_DURATION = 50;
export const TIMEOUT_LEAVE_DURATION = 150;
export const DROPDOWN_ENTER_DURATION = 250;
export const COUNT_TRANSITION_DURATION = 250;
export const MAX_COLUMN_WIDTH = 350;
// Breakpoints in pixels
export const DESKTOP_BREAKPOINT_GLOBAL_NAV = 1024;
export const DESKTOP_BREAKPOINT_CTA_SUBNAV = 1280;
// HTML Constants
export const CTA_SUBNAV_MOBILE_DROPDOWN_MENU_ID = 'cta-subnav-mobile-dropdown-menu';
export const GLOBAL_NAV_DESKTOP_CART_CONTENT_ID = 'global-nav-desktop-cart-content';
export const GLOBAL_NAV_MOBILE_CART_CONTENT_ID = 'global-nav-mobile-cart-content';
// Scroll direction throttle time in milliseconds
export const TIMEOUT_SCROLL_DIRECTION_THROTTLE = 100;
export const GLOBAL_NAV_MOBILE_IN_VIEW_OFFSET = 50;
export const MENU_TOGGLE_SELECTOR = '.__menu_toggle_focus';
